import React, { useEffect } from "react";
import styled from "styled-components";
import ProductItem from "./ProductItem";

const ProductItemList = ({
  items,
  addToCart,
  decreaseCartItem,
  background,
  setShowLimitDialog,
  ...rest
}) => {
  return (
    <ProductItemListContainer {...rest}>
      {items &&
        items.map(({ id, title, image, quantity, price }) => (
          <ProductItem
            key={id}
            id={id}
            title={title}
            quantity={quantity}
            image={image}
            price={price}
            setShowLimitDialog={setShowLimitDialog}
            isSelected={quantity !== undefined}
            func={() => addToCart(id)}
            decreaseCartItem={() => decreaseCartItem(id)}
            background={background}
          />
        ))}
    </ProductItemListContainer>
  );
};

const ProductItemListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export default ProductItemList;
